import * as React from 'react';
import {Helmet} from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import {Breadcrumb, BreadcrumbItem} from "reactstrap";
import {Link} from "react-router-dom";
import Container from "@material-ui/core/Container";
import ConsultationBookingForm from "../InquiryBookingForm";

export default function KTForm(){
  return(
    <React.Fragment>
      <Helmet>
        <meta name="description" content="KT Inquiry Form" />
        <title>Join KT</title>
      </Helmet>
      <CssBaseline />
      <main>
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Home</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>Knights Templar</BreadcrumbItem>
          </Breadcrumb>
          <Container maxWidth="md" style={{ paddingTop: "40px"}}>
            <ConsultationBookingForm
              title="Join the Knights Templar"
              siteID="kt"
            />
          </Container>
        </div>
      </main>

    </React.Fragment>
  );
}